import { ViewBookingCommentsInner } from "collins-js-sdk";
import React from "react";

interface DiaryBookingCardCustomerCommentsProps {
  comments?: ViewBookingCommentsInner[];
  bookingId?: string;
  showDetailedLabels?: boolean;
}

export const DiaryBookingCardCustomerComments =
  React.memo<DiaryBookingCardCustomerCommentsProps>(
    ({ comments, bookingId, showDetailedLabels }) => {
      if (!showDetailedLabels || !comments || comments.length === 0) {
        return null;
      }

      return (
        <div className="DiarySidebarListItem__customerNotes">
          <div className="DiarySidebarListItem__customerNotes__content">
            {comments.map((comment, index) => (
              <div
                key={`${bookingId}-${JSON.stringify(comment.time)}`}
                style={{
                  marginBottom: index < comments.length - 1 ? "4px" : "0"
                }}
              >
                &ldquo;{comment.comment}&rdquo;
              </div>
            ))}
          </div>
        </div>
      );
    }
  );

DiaryBookingCardCustomerComments.displayName =
  "DiaryBookingCardCustomerComments";
